export default {
    roundToMultiple:(num,multiple)=>{
		return Math.round(num / multiple) * multiple;
    }
}
